import { IIconProps } from '../../types/IconProps.interface'

export const IconMaximize = ({ color = 'white' }: IIconProps) => {
  return (
    <svg className='w-full' fill='none' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.33333 6.66667L14 2M14 2H10M14 2V6M6.66667 9.33333L2 14M2 14H6M2 14V10'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
